// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel {
    static getAttributeTypeMap() {
        return ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel.attributeTypeMap;
    }
}
ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel.discriminator = undefined;
ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel.additionalProperties = false;
ScriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel.attributeTypeMap = [
    {
        "name": "fileUrl",
        "baseName": "fileUrl",
        "type": "string"
    },
    {
        "name": "outputFileName",
        "baseName": "outputFileName",
        "type": "string"
    },
    {
        "name": "fileData",
        "baseName": "fileData",
        "type": ""
    },
];
//# sourceMappingURL=scriptsDocumentsV2FillablePdfGenerateFillablePdfRequestModel.js.map